export const customSelectInit = () => {
  const customSelectWrappers = document.querySelectorAll(
    ".custom-select-wrapper"
  );

  customSelectWrappers.forEach((wrapper) => {
    const selected = wrapper.querySelector(".custom-select-label");
    const customSelect = wrapper.querySelector(".custom-select");
    const options = customSelect.querySelector(".custom-select__options");

    selected.addEventListener("click", (e) => {
      e.stopPropagation();
      const isOpen = wrapper.classList.contains("isActive");
      if (isOpen) {
        wrapper.classList.remove("isActive");
        customSelect.classList.remove("isOpen");
      } else {
        customSelectWrappers.forEach((otherWrapper) => {
          otherWrapper.classList.remove("isActive");
          otherWrapper
            .querySelector(".custom-select")
            .classList.remove("isOpen");
        });

        wrapper.classList.add("isActive");
        customSelect.classList.add("isOpen");
      }
    });

    document.addEventListener("click", (e) => {
      if (!wrapper.contains(e.target)) {
        wrapper.classList.remove("isActive");
        customSelect.classList.remove("isOpen");
      }
    });

    const optionItems = options.querySelectorAll(".custom-select__option");
    optionItems.forEach((item) => {
      item.addEventListener("click", () => {
        const value = item.getAttribute("data-value");

        const url = new URL(window.location);
        url.searchParams.set("orderby", value);
        url.searchParams.set("paged", "1");
        window.location = url;
      });
    });
  });
};
